/**
 * Optional bridge so non-React modules can invalidate React Query after auth sync.
 * Registered from main.jsx after the QueryClient is created.
 */

/** @type {import('@tanstack/react-query').QueryClient | null} */
let appQueryClient = null;

/** @param {import('@tanstack/react-query').QueryClient} qc */
export function registerAppQueryClient(qc) {
  appQueryClient = qc;
}

export function invalidatePostAuthQueries() {
  if (!appQueryClient) return;
  appQueryClient.invalidateQueries({ queryKey: ['campaigns'] });
  appQueryClient.invalidateQueries({ queryKey: ['characters'] });
  appQueryClient.invalidateQueries({ queryKey: ['homebrew'] });
  appQueryClient.invalidateQueries({ queryKey: ['spellbooks'] });
  appQueryClient.invalidateQueries({ queryKey: ['spellbook-characters'] });
  appQueryClient.invalidateQueries({ queryKey: ['spellbook-linked-character'] });
  appQueryClient.invalidateQueries({ queryKey: ['spellbook-spells'] });
  appQueryClient.invalidateQueries({ queryKey: ['spellbook-compendium-spells'] });
}
